import { GemsApi_StoneClarity } from '@/graphql/api'
import { computed, type ComputedRef, type Ref, toValue } from 'vue'
import { findOrder } from '@/domain/stone/search/findOrder'

const ordered: GemsApi_StoneClarity[] = [
    GemsApi_StoneClarity.DiamondFl,
    GemsApi_StoneClarity.DiamondIf,
    GemsApi_StoneClarity.DiamondVvs1,
    GemsApi_StoneClarity.DiamondVvs2,
    GemsApi_StoneClarity.DiamondVs1,
    GemsApi_StoneClarity.DiamondVs2,
    GemsApi_StoneClarity.DiamondSi1,
    GemsApi_StoneClarity.DiamondSi2,
] as const

function findClarityOrder(code: GemsApi_StoneClarity) {
    return findOrder(ordered, code)
}

export function useOrderedClarity(
    shapes: Ref<GemsApi_StoneClarity[]> | (() => GemsApi_StoneClarity[])
): ComputedRef<GemsApi_StoneClarity[]> {
    return computed(() => {
        return toValue(shapes).sort(
            (a: GemsApi_StoneClarity, b: GemsApi_StoneClarity) => {
                const orderA = findClarityOrder(a)
                const orderB = findClarityOrder(b)

                return orderA - orderB
            }
        )
    })
}
